<template>
  <router-view />
</template>

<script setup>
import { onMounted } from "vue";
import { useAutoHideScrollbar } from "src/composables/useAutoHideScrollbar";

// Activer l'auto-hide de la scrollbar
useAutoHideScrollbar();

onMounted(() => {
  window.addEventListener("statusTap", () => {});
});
</script>
